"use strict";

import { shopConstants, commonConstants } from "../_constants";

export const shopTopPicksRequest = (payload) => {
    return {
        type: shopConstants.TOP_PICKS_REQUEST,
        payload,
    };
};

export const shopTopPicksComplete = (payload) => {
    return {
        type: shopConstants.TOP_PICKS_COMPLETE,
        payload,
    };
};

export const shopTrendingsRequest = (payload) => {
    return {
        type: shopConstants.TRENDINGS_REQUEST,
        payload,
    };
};

export const shopTrendingsComplete = (payload) => {
    return {
        type: shopConstants.TRENDINGS_COMPLETE,
        payload,
    };
};

export const shopFavouritesRequest = (payload) => {
    return {
        type: shopConstants.FAVOURITES_REQUEST,
        payload,
    };
};

export const shopFavouritesComplete = (payload) => {
    return {
        type: shopConstants.FAVOURITES_COMPLETE,
        payload,
    };
};

export const shopVoucherDetailsRequest = (payload) => {
    return {
        type: shopConstants.VOUCHER_DETAILS_REQUEST,
        payload,
    };
};

export const shopVoucherDetailsComplete = (payload) => {
    return {
        type: shopConstants.VOUCHER_DETAILS_COMPLETE,
        payload,
    };
};

export const setVoucherByValues = (payload) => {
    return {
        type: shopConstants.SET_VOUCHER_BY_VALUES,
        payload,
    };
};

export const shopConfirmOrderRequest = (payload) => {
    return {
        type: shopConstants.CONFIRM_ORDER_REQUEST,
        payload,
    };
};

export const shopConfirmOrderComplete = (payload) => {
    return {
        type: shopConstants.CONFIRM_ORDER_COMPLETE,
        payload,
    };
};

export const shopOrderDetailsRequest = (payload) => {
    return {
        type: shopConstants.ORDER_DETAILS_REQUEST,
        payload,
    };
};

export const shopOrderDetailsComplete = (payload) => {
    return {
        type: shopConstants.ORDER_DETAILS_COMPLETE,
        payload,
    };
};

export const shopVoucherWalletRequest = (payload) => {
    return {
        type: shopConstants.VOUCHER_WALLET_REQUEST,
        payload,
    };
};

export const shopVoucherWalletComplete = (payload) => {
    return {
        type: shopConstants.VOUCHER_WALLET_COMPLETE,
        payload,
    };
};

export const shopBrowseProductsRequest = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_REQUEST,
        payload,
    };
};

export const shopBrowseProductsComplete = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_COMPLETE,
        payload,
    };
};

export const shopBrowseProductsPopularFilterRequest = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_POPULAR_FILTER_REQUEST,
        payload,
    };
};

export const shopBrowseProductsPopularFilterComplete = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_POPULAR_FILTER_COMPLETE,
        payload,
    };
};

export const shopBrowseProductsCategoryRequest = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_CATEGORY_REQUEST,
        payload,
    };
};

export const shopBrowseProductsCategoryComplete = (payload) => {
    return {
        type: shopConstants.BROWSE_PRODUCTS_CATEGORY_COMPLETE,
        payload,
    };
};

export const shopBuyPointsRequest = (payload) => {
    return {
        type: shopConstants.BUY_POINTS_REQUEST,
        payload,
    };
};

export const shopBuyPointsComplete = (payload) => {
    return {
        type: shopConstants.BUY_POINTS_COMPLETE,
        payload,
    };
};

export const showPopup = (popupData) => ({
    type: commonConstants.SHOW_POPUP,
    payload: popupData,
  });
  
  export const hidePopup = () => ({
    type: commonConstants.HIDE_POPUP,
  });

  export const shopVoucherRedeemRequest = (payload) => {
    return {
        type: shopConstants.REDEEM_VOUCHER_REQUEST,
        payload,
    };
};

export const shopVoucherRedeemComplete = (payload) => {
    return {
        type: shopConstants.REDEEM_VOUCHER_COMPLETE,
        payload,
    };
};


export const shopRateVoucherRequest = (payload) => {
    return {
        type: shopConstants.RATE_VOUCHER_REQUEST,
        payload,
    };
};

export const shopRateVoucherComplete = (payload) => {
    return {
        type: shopConstants.RATE_VOUCHER_COMPLETE,
        payload,
    };
};

export const shopTLCGetPointBalanceRequest = (payload) => {
    return {
        type: shopConstants.SHOP_TLC_GET_POINT_BALANCE_REQUEST,
        payload,
    };
};

export const shopTLCGetPointBalanceComplete = (payload) => {
    return {
        type: shopConstants.SHOP_TLC_GET_POINT_BALANCE_COMPLETE,
        payload,
    };
};

export const shopTLCRebatePointsRequest = (payload) => {
    return {
        type: shopConstants.SHOP_TLC_REBAT_POINTS_REQUEST,
        payload,
    };
};

export const shopTLCRebatePointsComplete = (payload) => {
    return {
        type: shopConstants.SHOP_TLC_REBAT_POINTS_COMPLETE,
        payload,
    };
};

export const shopClearTLCRebatePoints = () => {
    return {
        type: shopConstants.SHOP_TLC_CLEAR_POINTS,
    };
}